import { faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactSortable } from 'react-sortablejs';
import { SortableProps } from '../../Interfaces/Props';
import { IconMove } from '../Icon';

function SortableComp(props: SortableProps) {
  return (
    <ul ref={props.listRef}>
      <ReactSortable
        id={props.ul_id}
        tag="ul"
        group={props.group}
        animation={200}
        delayOnTouchOnly={true}
        delay={2}
        handle=".handle"
        onEnd={props.onEnd}
        list={props.sortHandler}
        setList={props.setSortHandler}
      >
        {props.sortHandler.map((item) => (
          <li key={item.id} className="mb-2.5">
            <div className="bg-white dark:bg-[#1b2e4b] rounded-md border border-white-light dark:border-dark px-6 py-3.5 flex md:flex-row flex-col ltr:text-left rtl:text-right items-md-center">
              <div className="flex md:flex-row flex-col justify-between items-center flex-1 text-center md:text-left">
                <div className="font-semibold md:my-0 my-3 relative inline-block group">
                  <div className="text-dark dark:text-[#bfc9d4] text-base">
                    {item.name}
                  </div>
                  <div className="absolute top-0 left-full flex space-x-2 shadow-md overflow-hidden opacity-0 translate-x-full group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                    {props.handleUpdate && (
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        className="px-2 py-1 text-primary text-lg cursor-pointer hover:focus:outline-none"
                        onClick={() => props.handleUpdate!(Number(item.id))}
                      />
                    )}
                    {props.handleDelete && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        className="px-2 py-1 text-red-700 text-lg cursor-pointer hover:focus:outline-none"
                        onClick={() => props.handleDelete!(Number(item.id))}
                      />
                    )}
                  </div>
                </div>
                <div className="bg-[#ebedf2] dark:bg-black rounded handle px-2 py-1 text-slate-500 cursor-grab">
                  <IconMove />
                </div>
              </div>
            </div>
          </li>
        ))}
      </ReactSortable>
    </ul>
  );
}

export default SortableComp;
